var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import { Small } from '@finect/tabular-core/Small';
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { H3 } from '@finect/tabular-core/Headings';
import { AppLink } from '@finect/tabular-core/AppLink';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1t950il-0"
})(["display:flex;flex-direction:column;"]);
export var Header = styled.div.withConfig({
  displayName: "partials__Header",
  componentId: "sc-1t950il-1"
})(["display:flex;padding:24px 24px 0;margin-bottom:16px;"]);
export var PublishDate = styled(Small).withConfig({
  displayName: "partials__PublishDate",
  componentId: "sc-1t950il-2"
})(["", ";color:", ";"], getFont(-1, 'compact'), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.fontL;
});
export var ProfessionalBadge = styled.div.withConfig({
  displayName: "partials__ProfessionalBadge",
  componentId: "sc-1t950il-3"
})(["display:inline-block;position:relative;padding:", ";border-radius:", ";box-shadow:", ";margin-left:auto;margin-right:14px;background:", ";", ";white-space:nowrap;color:#fff;text-align:center;user-select:none;svg{position:absolute;top:4px;left:6px;}", ";"], function (_ref2) {
  var pro = _ref2.pro;
  return pro ? '3px 12px' : '3px 12px 3px 30px';
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.borderRadius, " ").concat(theme.borderRadius, " 0 0");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.boxShadow;
}, function (_ref5) {
  var theme = _ref5.theme,
    pro = _ref5.pro;
  return pro ? theme.mainColor : theme.colors.positive;
}, getFont(-1), maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: absolute;\n    right: 0;\n    z-index: 2;\n    border-radius: ", ";\n\n    ", ";\n  "])), function (_ref6) {
  var theme = _ref6.theme;
  return "0 0 ".concat(theme.borderRadius, " ").concat(theme.borderRadius);
}, function (_ref7) {
  var absolute = _ref7.absolute;
  return absolute ? "\n      right: 48px;\n      &:hover {\n        transform: translateY(21px) translateY(100%) translateX(-100%) translateX(24px);\n      }\n      " : null;
}));
export var Excerpt = styled(Paragraph).withConfig({
  displayName: "partials__Excerpt",
  componentId: "sc-1t950il-4"
})(["margin-top:30px;font-size:15px;line-height:24px;word-wrap:break-word;"]);
export var Footer = styled.div.withConfig({
  displayName: "partials__Footer",
  componentId: "sc-1t950il-5"
})(["padding:0 24px 9px;"]);
export var Entry = styled.div.withConfig({
  displayName: "partials__Entry",
  componentId: "sc-1t950il-6"
})(["position:relative;border:1px solid ", ";border-radius:4px;margin-bottom:2rem;", " ", ""], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.ui;
}, function (_ref9) {
  var theme = _ref9.theme;
  return "box-shadow: ".concat(theme.shadows.lightBlack, ";");
}, function (_ref10) {
  var isAdviser = _ref10.isAdviser,
    theme = _ref10.theme;
  return isAdviser ? "border: 2.5px solid ".concat(theme.mainColor, ";") : '';
});
export var Meta = styled.div.withConfig({
  displayName: "partials__Meta",
  componentId: "sc-1t950il-7"
})(["display:block;padding:0 24px;div + small{margin-left:9px;}"]);
export var Body = styled.div.withConfig({
  displayName: "partials__Body",
  componentId: "sc-1t950il-8"
})(["display:block;position:relative;padding:0 24px;"]);
export var Features = styled.div.withConfig({
  displayName: "partials__Features",
  componentId: "sc-1t950il-9"
})(["display:block;max-width:900px;padding:16px 24px 0;margin:32px auto;", ";"], minMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: wrap;\n    padding: 16px 24px 0 24px;\n  "]))));
export var ReviewFeature = styled.div.withConfig({
  displayName: "partials__ReviewFeature",
  componentId: "sc-1t950il-10"
})(["display:flex;padding:5px 0;", ";"], minMediaQueries.tablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    width: 50%;\n    padding-right: 50px;\n    padding-left: 50px;\n  "]))));
export var FeatureName = styled.div.withConfig({
  displayName: "partials__FeatureName",
  componentId: "sc-1t950il-11"
})(["display:inline-block;min-width:120px;margin-right:8px;vertical-align:text-bottom;font-size:14px;", ";font-weight:400;line-height:20px;"], getFont(-1, 'compact'));
export var FeatureValue = styled.div.withConfig({
  displayName: "partials__FeatureValue",
  componentId: "sc-1t950il-12"
})(["margin-left:auto;svg{margin-left:3px;}"]);
export var ReviewTitle = styled(H3.withComponent('div')).withConfig({
  displayName: "partials__ReviewTitle",
  componentId: "sc-1t950il-13"
})(["width:100%;", ""], function (_ref11) {
  var owned = _ref11.owned;
  return owned && css(["", ";"], maxMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        margin-top: 50px;\n    "]))));
});
export var Title = styled(AppLink).withConfig({
  displayName: "partials__Title",
  componentId: "sc-1t950il-14"
})(["font-size:18px;font-weight:700;line-height:27px;color:currentColor;&:hover{color:", ";text-decoration:underline;}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.linkColor;
});
export var Deleted = styled.div.withConfig({
  displayName: "partials__Deleted",
  componentId: "sc-1t950il-15"
})(["padding:18px 15px;border-radius:4px;margin-bottom:1rem;background-color:", ";color:#fff;"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.font;
});